import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pages.NumPages > 1)?_c('div',{staticClass:"d-flex"},[(!_vm.left)?_c(VSpacer):_vm._e(),_c(VBtn,{attrs:{"icon":"","disabled":_vm.pages.CurrentPageId === 0},on:{"click":_vm.back}},[_c(VIcon,[_vm._v("mdi-chevron-left")])],1),_c(VBtn,{attrs:{"icon":"","disabled":_vm.pages.CurrentPageId === _vm.pages.NumPages - 1},on:{"click":_vm.fwd}},[_c(VIcon,[_vm._v("mdi-chevron-right")])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }